import { useNavigate } from 'react-router-dom';
import { NodeAccessOperation, NodeSupplierContract } from '@prisma/client';
import { Card, Layout, Space, Table, Tag } from 'antd';

import { PageLayout, Tables } from '@app/web-components';

import { useGetContractSummary } from '../data';

export type LandingPageItem = {
  supplierContract: NodeSupplierContract;
  operations: {
    operation: string;
    count: number;
  }[];
};

export const LandingPage = () => {
  const navigate = useNavigate();

  const { getTableProps } = Tables.useTableState<LandingPageItem>('Contracts', [
    {
      title: 'Contract Name',
      width: 150,
      dataIndex: ['supplierContract', 'contractName'],
      ellipsis: true,
    },
    {
      title: 'Contract Number',
      width: 150,
      dataIndex: ['supplierContract', 'contractNumber'],
    },
    {
      title: 'Supplier Name',
      width: 150,
      dataIndex: ['supplierContract', 'supplierName'],
    },
    {
      title: 'Operations',
      dataIndex: 'operations',
      width: 300,
      render: (operations) => (
        <Space direction="horizontal">
          {operations.map(({ operation, count }) => (
            <Tag color={operation === NodeAccessOperation.ADD ? 'green' : 'red'}>
              {operation === NodeAccessOperation.ADD ? 'Added' : 'Removed'} {count} CW{count > 1 ? 's' : ''}
            </Tag>
          ))}
        </Space>
      ),
    },
  ]);

  const queryResult = useGetContractSummary<LandingPageItem>();

  return (
    <Layout.Content>
      <div
        style={{
          padding: 24,
          margin: 'auto',
          maxWidth: 1400,
          minHeight: 0,
        }}
      >
        <Card>
          <PageLayout.Title title="Pending Contracts" />
          {/* <div {...getToolbarProps({ queryResult, items: [] })} /> */}
          <Table
            {...getTableProps(queryResult)}
            onRow={(record, index) => ({
              onClick: (event) => navigate(`/approvals?contractNumber=${record.supplierContract.contractNumber}`),
            })}
          />
        </Card>
      </div>
    </Layout.Content>
  );
};
